import styled from 'styled-components';

export const Container = styled.div<{ $noSpacing: boolean }>`
  padding: ${({ theme, $noSpacing }) =>
    $noSpacing ? 0 : `${theme.spacing(3)} 0 0`};
`;
